import { render } from "./termsReport.vue?vue&type=template&id=3de77496&scoped=true"
import script from "./termsReport.vue?vue&type=script&lang=js"
export * from "./termsReport.vue?vue&type=script&lang=js"

import "./termsReport.vue?vue&type=style&index=0&id=3de77496&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de77496"]])

export default __exports__